/** @format */

import { Directive, ElementRef, HostListener } from "@angular/core";
import { Logger } from "@html-core";

@Directive({
   standalone: false,
   selector: "[open-chrome-link]"
})
export class OpenChromeLinkDirective {
   constructor(private el: ElementRef) {}

   @HostListener("click", ["$event"]) onClick(event: MouseEvent) {
      if (chrome?.runtime && typeof chrome.runtime.sendMessage === "function") {
         this.addClickListener(event);
      }
   }
   private addClickListener(event) {
      event.preventDefault();
      event.stopPropagation();
      chrome.runtime.sendMessage({ type: "openLinkWithoutOpener", url: this.el.nativeElement.href }, (response) => {
         if (response) {
            Logger.info("Link opened");
         }
      });
   }
}
